import { render, staticRenderFns } from "./SkeletonAnimate.vue?vue&type=template&id=3c29c81c&scoped=true"
import script from "./SkeletonAnimate.vue?vue&type=script&lang=js"
export * from "./SkeletonAnimate.vue?vue&type=script&lang=js"
import style0 from "./SkeletonAnimate.vue?vue&type=style&index=0&id=3c29c81c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c29c81c",
  null
  
)

export default component.exports